@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../settings-page.module.less';
@import (reference) '../../../../constants/spacing.module.less';

.grid-subcontainer() {
  display: grid;
  grid-template-columns:
    35px minmax(175px, 5fr) minmax(75px, 2fr) minmax(55px, 1fr)
    95px;
  grid-template-rows: auto;
}

.grid-item() {
  display: flex;
  align-items: center;
  padding: @settings-page--table--cell--padding;
  overflow: hidden;
}

.grid-container {
  border: @settings-page--table--border;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
}

.grid-header {
  font-weight: @settings-page--table--header--cell--font-weight;
  border-bottom: @settings-page--table--border;
  .grid-subcontainer();

  .header-item {
    .grid-item();
    background: @settings-page--table--header--cell--background-color;

    &.active-header {
      justify-content: center;
    }
    &:last-child {
      display: flex;
      justify-content: center;
    }
  }
}

.grid-row {
  .grid-subcontainer();
  border-bottom: @settings-page--table--border;
  background: @settings-page--table--body--cell--background-color;

  &:last-of-type {
    border-bottom: none;
  }

  &:hover {
    background: @settings-page--automation-rules-grid-row--hover--background-color;
  }

  .grid-item {
    .grid-item();
  }

  .activity {
    .grid-item();
    justify-content: center;
  }

  .actions {
    .grid-item();
    justify-content: center;
  }
}

// @design-input-pending
.error {
  color: var(--red-700);
  height: 16px;
  width: 16px;
}

.loading {
  height: 36px;
  margin: auto;
}

.flying {
  border: @settings-page--table--border;
  background: @settings-page--automation-rules-grid-dragging--background-color;
}
